const normalizeSearch = (value) => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();

export const getCompletedCustomerOptions = (rows, selectedCustomers = []) => {
    const customers = new Map();
    [...selectedCustomers, ...rows.map((row) => row.customer)].forEach((customer) => {
        const label = String(customer || '').trim();
        const key = normalizeSearch(label);
        if (key && !customers.has(key)) customers.set(key, { label, value: label });
    });
    return Array.from(customers.values()).sort((a, b) => a.label.localeCompare(b.label));
};

export const filterCompletedMovements = (rows, customers = [], search = '') => {
    const selected = new Set(customers.map(normalizeSearch));
    const terms = normalizeSearch(search).split(/\s+/).filter(Boolean);
    return rows.filter((row) => {
        if (selected.size && !selected.has(normalizeSearch(row.customer))) return false;
        const text = [row.machineId, row.machineType, row.customer, row.toLocation, row.technician, row.completedBy]
            .map(normalizeSearch).join(' ');
        return terms.every((term) => text.includes(term));
    });
};

// Preserve legacy records without using the date of an unrelated edit.
export const sortCompletedMovements = (rows) => [...rows].sort((left, right) => {
    const timestamp = (row) => new Date(row.completedAt || row.actualInstallationAt || row.createdAt || 0).getTime() || 0;
    return timestamp(right) - timestamp(left);
});

export const filterByCompletionRange = (rows, range) => {
    const from = range?.from ? new Date(range.from).getTime() : -Infinity;
    const end = range?.to ? new Date(range.to) : null;
    if (end) end.setHours(23, 59, 59, 999);
    const to = end ? end.getTime() : Infinity;
    return rows.filter((row) => {
        const date = new Date(row.completedAt || row.actualInstallationAt || row.createdAt || 0).getTime();
        return date >= from && date <= to;
    });
};
